const REGEX_GET_FILENAME = new RegExp("[^\\/]*(?=\\.\\w+$)")

export const parseUrlToGetFileNameWithoutPrefix = (url: string): string => {
    const fileName = REGEX_GET_FILENAME.exec(url || "") || [""]
    return fileName[0]
}
